export default __webpack_public_path__ + "static/media/dislike.247df330.svg";